/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { call, debounce, put, select, takeLatest } from 'redux-saga/effects';
import { UPDATED_SETTINGS } from '@nebula/airglow-plugin-unified-shell/dist/actions';

import enablePlugins from './enable.plugins.saga';
import { validationEndpoint, watchShellSettingsChanges } from '../data/prefabs';
import {
  APPLY_SETTINGS,
  applySettings
} from '../actions';
import { selectValidationPluginSettings } from '../selectors';

/**
 * When we write settings to the session, we usually want to apply t
 */
export function* doUpdateSettings() {
  const watchViews = yield select(watchShellSettingsChanges.isOn);

  if (watchViews) {
    yield put(applySettings());

    // stop watching for changes
    yield put(watchShellSettingsChanges.turnOffAction);
  }
}

export function* applyShellSettings() {
  const validationEndpointValue = yield select(validationEndpoint.value);
  if (validationEndpointValue) {
    const settings = yield select(selectValidationPluginSettings);
    validationEndpointValue.updateSettings(settings);
  }
  yield call(enablePlugins);
}

export function* watchUpdateShellSettingsSaga() {
  yield debounce(1000, UPDATED_SETTINGS, doUpdateSettings);
}

export function* watchApplyShellSettingsSaga() {
  yield takeLatest(APPLY_SETTINGS, applyShellSettings);
}
